document.addEventListener('DOMContentLoaded', function () {

    // Find all copy buttons
    const copyButtons = document.querySelectorAll('.sidestack-copy-block .copy-button');

    copyButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            // Get the command text from the data attribute
            const commandText = this.getAttribute('data-command');
            // Remove HTML tags if any
            const cleanText = commandText.replace(/<[^>]*>/g, '');
            // Copy to clipboard functionality, NOTE!! Working ONLY with secure connection(SSL)
            navigator.clipboard.writeText(cleanText).then(() => {
                // Visual feedback
                const icon = this.querySelector('i');
                const originalClass = icon.className;
                // Change icon to checkmark
                icon.className = 'fa-solid fa-check text-green-400';
                // Reset after 2 seconds
                setTimeout(() => {
                    icon.className = originalClass;
                }, 2000);
            }).catch(err => {
                console.error('Failed to copy:', err);
                alert('Failed to copy to clipboard');
            });
        });
    });
});